/** The folder a file's relative path puts it in, or "" for a file at the root. */
export function folderOf(relativePath: string): string {
  return relativePath.split("/").slice(0, -1).join("/");
}
